import { render, staticRenderFns } from "./investFilter.vue?vue&type=template&id=205d83bb&scoped=true&"
import script from "./investFilter.vue?vue&type=script&lang=js&"
export * from "./investFilter.vue?vue&type=script&lang=js&"
import style0 from "./investFilter.vue?vue&type=style&index=0&id=205d83bb&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.9.6@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "205d83bb",
  null
  
)

export default component.exports